import { LayoutShell } from '@invisoutlet/shared/components';
import type { ReactNode } from 'react';
import { InternalSidebar } from './internal-sidebar.js';

interface InternalLayoutProps {
  children: ReactNode;
  title?: string;
}

export function InternalLayout({ children, title }: InternalLayoutProps) {
  const topBar = title ? (
    <div className="flex items-center">
      <h1 className="text-sm font-semibold text-text-primary">{title}</h1>
    </div>
  ) : undefined;

  return (
    <LayoutShell sidebar={<InternalSidebar />} topBar={topBar}>
      {children}
    </LayoutShell>
  );
}
